<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

	<div>

	<span v-if="!item.game.time_min">-</span>

	<span v-if="item.game.time_min">{{ item.game.time_min }}</span>

	<span v-if="item.game.time_min !== item.game.time_max && item.game.time_min && item.game.time_max"><span class="divide">-</span>{{ item.game.time_max }}
	</span>

	</div>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted']

}

</script>

<style scoped>

.divide {
	display: inline-block;
	margin: 0px 4px;
}

.is-mobile .divide {
	margin: 0px 2px;
}

</style>